import React from "react";
import ProductCard from "../ProductCont/ProductCont";
import ShimmerCard from "../../components/ShimmerCard/ShimmerCard";

const productsdummy = [
  {
    image: "/images/white-shirt.png",
    title: "1009 HEAVYWEIGHT T-SHIRT",
    gsm: "275 GSM JERSEY",
    originalPrice: 35,
    discountedPrice: 32,
    colors: ["#000", "#fff", "#d9d9d9", "#6c6c6c", "#eae1d8"],
  },
  {
    image: "/images/beige-shirt.png",
    title: "1009 HEAVYWEIGHT T-SHIRT",
    gsm: "275 GSM JERSEY",
    originalPrice: 35,
    discountedPrice: 32,
    colors: ["#000", "#c3bfb3", "#eae1d8", "#fff", "#6c6c6c"],
  },
  {
    image: "/images/navy-shirt.png",
    title: "1009 HEAVYWEIGHT T-SHIRT",
    gsm: "275 GSM JERSEY",
    originalPrice: 35,
    discountedPrice: 32,
    colors: ["#000", "#24283b", "#c3bfb3", "#fff", "#eae1d8"],
  },
  {
    image: "/images/gray-shirt.png",
    title: "1009 HEAVYWEIGHT T-SHIRT",
    gsm: "275 GSM JERSEY",
    originalPrice: 35,
    discountedPrice: 32,
    colors: ["#000", "#d9d9d9", "#6c6c6c", "#fff", "#c3bfb3"],
  },
];

const ProductList = ({ loading, products, onProductClick, title }) => {
  let myproducts = [...products];

  console.log("products areeeeeeeeee", products);

  const renderShimmerCards = () => {
    return Array.from({ length: 6 }).map((_, idx) => (
      <ShimmerCard key={`shimmer-${idx}`} />
    ));
  };

  return (
    <section className=" py-1 bg-[#fff]">
      <h2 className="text-md md:text-xl  font-pop text-[#222] font-semibold mb-6 max-sm:mb-3">
        {title ? title : "YOU MAY ALSO LIKE"}
      </h2>
      <div
        className="flex flex-row gap-1 overflow-x-scroll scrollbar-hide  max-sm:!gap-0"
        style={{
          overflowX: "auto",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE 10+
        }}
      >
        {loading ? (
          renderShimmerCards()
        ) : (
          <>
            {myproducts?.filter((product) => product?.status !== "inactive")
    .map((product, idx) => (
              <ProductCard
                key={idx}
                {...product}
                onProductClick={onProductClick}
              />
            ))}
          </>
        )}
      </div>
    </section>
  );
};

export default ProductList;
